// @flow
import * as React from 'react';
import timeSpentManager from 'app/common/lib/react/TimeSpentManager';
import { TimeSpent as BaseTimeSpent, type TimeSpentProps } from 'app/packages/time-spent';

const TimeSpent = (props: TimeSpentProps) => (
  <BaseTimeSpent {...props} timeSpentManager={timeSpentManager} />
);

export default TimeSpent;
